<template>
  <div class="who-we-are-page">
    <!-- Section 1: A Heartfelt Legacy -->
    <div class="legacy-section">
      <div class="row">
        <div class="col-6 legacy-image">
          <img :src="section1" alt="PERKI Legacy" class="hero-image" />
        </div>
        <div class="col-6 legacy-content">
          <div class="content-wrapper">
            <h1 class="legacy-title">
              A Heartfelt Legacy,<br />
              <span class="since">Since 1957</span>
            </h1>
            <div class="legacy-text">
              <p>
                Perkumpulan Kardiologi Indonesia (PERKI) was founded on November 16, 1957, initiated
                by Dr. Gan Tjong Bing, and officially established on November 28, 1957, due to the
                increasing of interest in the study of cardiovascular diseases in the 1950s and the
                development of relationships between cardiovascular experts in Indonesia and abroad.
                As time passed and knowledge of cardiovascular progressed, the association continued
                to develop, and currently has more than 1,600 vascular specialists spread throughout
                Indonesia. PERKI has undergone two name changes in 1994 and 1998. From the decision
                of KOPERKI VIII in 1998, the name was changed to the Perhimpunan Dokter Spesialis
                Kardiovaskular Indonesia, and its headquarter is located in DKI Jakarta.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="text-center"
      style="
        background-color: #282828;
        color: white;
        padding: 5rem 2rem;
        font-family: 'Arial', sans-serif;
      "
    >
      <p style="font-size: 1.2rem; font-weight: 600; letter-spacing: 0.5px; margin-bottom: 1rem;">
        Vision and Mission
      </p>
      <h1
        style="
          color: white;
          font-size: 3rem;
          font-weight: 700;
          line-height: 1.1;
          margin-bottom: 0.5rem;
        "
      >
        Guide by Vision
      </h1>
      <h1 style="color: #e10f28; font-size: 3rem; font-weight: 700; line-height: 1.1;">
        Driven by Mission
      </h1>

      <div
        class="row"
        style="
          max-width: 1200px;
          margin: 4rem auto 0 auto;
          display: flex;
          align-items: flex-start;
        "
      >
        <div class="col-6" style="padding: 0 1.5rem;">
          <div style="display: flex; align-items: flex-start; gap: 1.5rem;">
            <div
              style="
                width: 80px;
                height: 80px;
                background-color: #fff;
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                flex-shrink: 0;
              "
            >
              <img :src="icon1" alt="Vision Icon" style="transform: scale(0.6);" />
            </div>
            <div style="text-align: left;">
              <h3
                style="
                  color: white;
                  font-weight: 600;
                  font-size: 1.8rem;
                  margin-top: 0;
                  margin-bottom: 1rem;
                "
              >
                Vision
              </h3>
              <p style="font-size: 1.1rem; line-height: 1.7; margin: 0;">
                To become a professional organization which is trusted in the field of
                cardiovascular medicine, keeping up with the challenges and developments of our
                time, at the regional, national, and international level.
              </p>
            </div>
          </div>
        </div>

        <div class="col-6" style="padding: 0 1.5rem;">
          <div style="display: flex; align-items: flex-start; gap: 1.5rem;">
            <div
              style="
                width: 80px;
                height: 80px;
                background-color: #fff;
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                flex-shrink: 0;
              "
            >
              <img :src="icon2" alt="Mission Icon" style="transform: scale(0.6);" />
            </div>
            <div style="text-align: left;">
              <h3
                style="
                  color: white;
                  font-weight: 600;
                  font-size: 1.8rem;
                  margin-top: 0;
                  margin-bottom: 1rem;
                "
              >
                Mission
              </h3>
              <ol style="padding-left: 20px; margin: 0; font-size: 1.1rem; line-height: 1.7;">
                <li style="margin-bottom: 1rem;">
                  Provide high-quality cardiovascular care to patients
                </li>
                <li style="margin-bottom: 1rem;">
                  Conduct and support research that advances the field of cardiovascular medicine
                </li>
                <li>
                  Educate healthcare professionals, patients, and the public about cardiovascular
                  health and disease prevention
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Section 5: Organizational Structure -->
    <div class="structure-section">
      <div class="row">
        <div class="col-6 structure-content">
          <h2>Organizational Structure</h2>
          <p>
            Our structured approach ensures efficient operations and clear leadership pathways,
            enabling us to serve the cardiovascular community effectively.
          </p>
          <!-- <a-button type="primary" class="view-structure-btn">VIEW FULL STRUCTURE</a-button> -->
        </div>
        <div class="col-6 structure-image">
          <img :src="structure" alt="Organizational Structure" class="structure-img" />
        </div>
      </div>
    </div>
    <!-- Section 4: Anagrams -->
    <div class="anagrams-section">
      <div class="anagrams-grid">
        <div class="anagram-card" v-for="(anagram, index) in anagrams" :key="index">
          <div class="anagram-content">
            <h3 class="anagram-title">{{ anagram.title }}</h3>
            <p class="anagram-description">{{ anagram.description }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Section 6: Anggaran Dasar -->
    <div class="ad-section">
      <div class="row">
        <div class="col-6 ad-image">
          <img :src="art" alt="Anggaran Dasar" class="ad-img" />
        </div>
        <div class="col-6 ad-content">
          <h2>Anggaran Rumah Tangga Koperki XIX</h2>
          <a href="/pdf/ANGGARAN-RUMAH-TANGGA.pdf" download="ANGGARAN-RUMAH-TANGGA.pdf">
            <a-button type="primary" class="download-ad-btn"
              >DOWNLOAD ANGGARA RUMAH TANGGA</a-button
            >
          </a>
        </div>
      </div>
    </div>
    <div class="ad-section">
      <div class="row">
        <div class="col-6 ad-image">
          <img :src="ad" alt="Anggaran Dasar" class="ad-img" />
        </div>
        <div class="col-6 ad-content">
          <h2>Anggaran Dasar Koperki XIX</h2>
          <a href="/pdf/ANGGARAN-DASAR.pdf" download="ANGGARAN-DASAR.pdf">
            <a-button type="primary" class="download-ad-btn">DOWNLOAD ANGGARAN DASAR</a-button>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import section1 from '@/assets/img/about-us/who-we-are/section-1.png'
import icon1 from '@/assets/img/about-us/who-we-are/icon-1.png'
import icon2 from '@/assets/img/about-us/who-we-are/icon-2.png'
import structure from '@/assets/img/about-us/who-we-are/structure.png'
import ad from '@/assets/img/about-us/who-we-are/anggaran-dasar.png'
import art from '@/assets/img/about-us/who-we-are/anggaran-rumah-tangga.png'

export default {
  name: 'WhoWeAre',
  data() {
    return {
      section1,
      icon1,
      icon2,
      structure,
      ad,
      art,
      anagrams: [
        {
          title: 'Advisory Board',
          description: `Dr. Anwar Santoso, MD, FIHA
Suhendiwijaya, MD, FIHA
Dr. Isman Firdaus, MD, FIHA
Radityo Prakoso, MD, FIHA
Prof Dr. Mohammad Saifur Rohman, MD, FIHA`,
        },
        {
          title: 'Board of Ethics',
          description: `Head of Board:
Dr. Muhammad Munawar, MD, FIHA

Staff:
Dolly RD Kaunang, MD, FIHA
Anna Ulfah Rahajoe, MD, FIHA
Agnes Lucia Panda, MD, FIHA
Sasmojo Widito, MD, FIHA
A. Fauzi Yahya, MD, FIHA
Sunu Budhi Raharjo, MD, FIHA
Syarief Hidayat, MD, FIHA
Sunarya Soerianata, MD, FIHA
Pradana Tedjasukmana, MD, FIHA
Prof. Dr. Lucia Kris Dinarti, MD, FIHA`,
        },
        {
          title: 'Department of Organization',
          description: `Head of Dept:
Adrian Masno, MD, FIHA

Member:
Jusup Endang, MD, FIHA
Eko Saputra, MD, FIHA
Dr.Akhtar Fajar Muzakkir Ali Aspar, MD, FIHA
Bagus Andi Pramono, MD, FIHA
Bayu Setia, MD, FIHA
Devie Caroline, MD, FIHA
Ahmad Handayani, MD, FIHA`,
        },
        {
          title: 'President of Indonesian Heart Association',
          description: `President: Dr. Ade Meidian Ambari, MD, FIHA
Vice President I: Faisal Habib, MD, FIHA
Vice President II: Jordan Bakhriansyah, MD, FIHA
Vice President III: Afdhalun A Hakim, MD, FIHA
Secretary General: Berlian idriansyah Idris, MD, PhD, DSc, FIHA
Vice Secretary I: Dr. Abdul Hakim Alkatiri, MD, FIHA
Vice Secretary II: Magma Purnawan Putra, MD, FIHA
Vice Secretary III: Dr. Muhammad Fadil, MD, FIHA
Vice Secretary IV: Virezza Pratama, MD, FIHA
Treasurer I: Rina Ariani, MD, FIHA
Treasurer II: Febtusia Puspitasari, MD, FIHA`,
        },
        {
          title: 'Department of Advocacy, & Legislation Policies',
          description: `Head of Dept:
Zainuddin Khan, MD

Member:
Eko Saputra, MD, FIHA
Andria Priyana, MD, FIHA
Dian Yaniarti Hasanah, MD, FIHA
Bhayu Hangaddi Nugroho, MD, FIHA
Achmad Yusri Rachman Diartoputro, MD, FIHA
Gusti Rilfansyah, MD, FIHA
Priyandini Wulandari, MD, FIHA
Aditya Agita Sembiring, MD, FIHA
Doni Yugo Hermanto, MD, FIHA
Arief Fadhillah, MD, FIHA
Fachmi Ahmad Muslim, MD, FIHA
Fahmi Idrus Shahab, MD, FIHA
Eka Fithra E.fl, MD, FIHA
Venice Chairiadi, MD, FIHA`,
        },
        {
          title: 'Department of Business Empowerment and Member Welfare',
          description: `Head of Dept:
Haryadi, MD, FIHA

Member:
Dr. Antonia Anna Lukito, MD, FIHA
Olivia Handayani Nelwan, MD, FIHA
R. R. Hendriarti Satoto, MD, MARS, FIHA
Zaenab Dja'far, MD, MKes, FIHA
Christian Pramudita Budianto, MD, FIHA
Tengku Winda Ardini, MD, FIHA
Putl Sarah Saus, MD, FIHA
Sebastian Andy Manurung, MD, FIHA`,
        },
        {
          title: 'Department of Information Communication & Community Service',
          description: `Head of Dept:
Dr. Yusra Pintaningrum, MD, FIHA

Member:
Dr. Vito Anggarino Damay, MD, FIHA
Victor Joseph, MD, FIHA
Agus Riawan, MD, FIHA
I Made Putra Swi Antara, MD, FIHA
Dr. Hendri Susilo, MD, FIHA
Bobby Arfhan Anwar, MD, FIHA
Sony Hilal Wicaksono, MD, FIHA
Indah Sukmawati Prihatiningsih, MD, FIHA`,
        },
        {
          title: 'Department of Law Membership Defence and Advocacy',
          description: `Head of Dept:
Ismi Purnawan, MD, FIHA

Member:
Emanoel Oepangat, MD, FIHA
Dr. Sifitri Laksino Purnisdiana, MD, MARS, MH, FIHA
Achmad Hafiedz Azis Kartasamihardja, , MD, MH.Kes, FIHA
Adi Purnawarman, MD, FIHA
Andika Sitepu, MD, FIHA
Dr. Budi Bakti Dharmaadjati, MD, FIHA
Supono Sugito, MD, FIHA
Meity Ardiana, MD, FIHA
Dr. I Made Junior Rina Artha, MD, FIHA`,
        },
        {
          title: 'Department of Research & Development and International Relations',
          description: `Head of Dept:
Bambang Dwiputra, MD, FIHA

Member:
Dr. Muhammad Ridwan, MD, FIHA
Dwita Rian Desandri, MD, FIHA
Suci Andriani, MD, FIHA
Irma Maghfirah, MD, FIHA
Evan Kurniawan, MD, FIHA
Wishnu Aditya Widodo, MD, FIHA`,
        },
        {
          title: 'Department of National Health Insurance Advocacy',
          description: `Head of Dept:
Budi Satrijo, MD, FIHA

Member:
Ismir Fahri, MD, FIHA
Real Kusumajaya Marsam, MD, MSc, FIHA
Mefri Yanni, MD, FIHA
Taofan, MD, FIHA
Gugun Iskandar Hidayat, MD, FIHA
Muhammad Yolandi Sumadio, MD, FIHA
Az Hafid Nashar, MD, FIHA`,
        },
        {
          title: 'Special Board of Education and Training',
          description: `Head of Dept:
Siska Suridanda Danny, MD, FIHA

Member:
Olfi Leyla, MD, FIHA
Dasdo Antonius Sinaga, MD, FIHA
Wahyu Aditya, MD, FIHA
Rissa Ummy Setiani, MD, FIHA
Asmoko Resta Permana, MD, FIHA
Firman Fauzan Arief Luthfie, MD, FIHA
Made Satria Yudha Dewangga, MD, FIHA
Vebiona Kartini Prima Putri, MD, FIHA
I Nyoman Wiryawan, MD, FIHA`,
        },
        {
          title: 'Cardiovascular Emergency Commission',
          description: `Head of Comm:
Dian Zamroni, MD, FIHA

Member:
Agung Fabian Chandranegara, MD, FIHA
Alexandra Gabriella, MD, FIHA
Rizki, MD, FIHA
Andika Rizki Lubis, MD, FIHA
Febyanti Hartono, MD, FIHA
Yuke Sarastri, MD, FIHA
Haikal, MD, FIHA`,
        },
        {
          title: 'Special Board of Education and Profession Development',
          description: `Head of Board:
Prof. Dr. Amiliana Mardiani Soesanto, MD, FIHA

Member:
Prof. Dr. Idar Mappangara, MD, FIHA
Estu Rudiktyo, MD, FIHA
Prof. Dr. Yoga Yuniadi, MD, FIHA
Prof. Dr. Teuku Heriansyah, MD, FIHA
Prof. Dr. J Nugroho Eko Putranto, MD, FIHA
Prof. Dr. Januar Wibawa Martha, MD, FIHA
Prof. Ganesja M Harimurti, MD, FIHA
Sodiqun Rifqi, MD, FIHA
Anggia Chaeruddin Lubis, MD, FIHA
Hauda El Rasyid, MD, FIHA
Mangiring Payer Lumban Toruan, MD, FIHA
Pipin Ardhianto, MD, FIHA
Habibie Arifianto, MKes, MD, FIHA
Mochammad Yusuf Alsagaf, MD, PhD, FIHA
I Kadek Susila Surya Darma, MD, FIHA
Dr. Indriwanto Sakidjan Atmosudigdo, MD, FIHA
Siti Elkana Nauli, MD, FIHA
Elen, MD, FIHA
Amir Aziz Alkatiri, MD, FIHA
Erika Maharani, MD, FIHA
Safir Sungkar, MD, FIHA
Heny Martini, MD, FIHA
Rarasan Soerarso Pratikto, MD, FIHA
Anggoro Budi Hartopo, MSc, MD, PhD, FIHA
Dr. Cut Aryfa Andra, MD, FIHA
Ardian Rizal, MD, FIHA
Dr. Nahar Taufiq, MD, FIHA
Dr. Rita Zahara, MD, FIHA
Badai Batara Tiksnadi, MD, FIHA
Dyah Wulan Anggrahini, MD, PhD, FIHA`,
        },
        {
          title: 'Working Groups',
          description: `Interventional Cardiology
Arrhytmias & Electrophysiology Pacing
Acute Cardiovascular Care
Heart Failure
Hypertension
Pulmonary Hypertensions
Echocardiography
Vascular Medicine
Woman Cardiology
Nuclear Cardiology & Cardiac Imaging
Atherosclerosis, Thrombosis, Lipidology and Regenerative Therapy
Pediatric Cardiology & Congenital Heart Disease`,
        },
      ],
    }
  },
}
</script>

<style scoped>
.who-we-are-page {
  font-family: 'Arial', sans-serif;
}

/* Common Styles */
.row {
  display: flex;
  margin: 0;
}

.col-6 {
  width: 50%;
  padding: 0;
}

.content-wrapper {
  max-width: 500px;
  margin: 0 auto;
}

/* Section 1: Legacy Section */
.legacy-section {
  min-height: 90vh;
  display: flex;
  align-items: center;
  background-color: #fff;
}

.hero-image {
  width: 100%;
  object-fit: contain;
  transform: scale(0.8);
}

.legacy-content {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem 4rem;
}

.legacy-title {
  font-size: 3.5rem;
  font-weight: 700;
  color: #e10f28;
  line-height: 1.1;
  margin-bottom: 2.5rem;
}

.since {
  color: #333;
  font-weight: 300;
}

.legacy-text p {
  font-size: 1.1rem;
  color: #666;
  line-height: 1.6;
  text-align: justify;
  margin: 0;
}

/* Section 2: Vision & Mission */
.vision-mission-section {
  min-height: 80vh;
  display: flex;
  align-items: center;
  background-color: #f8f9fa;
  padding: 2rem 0;
}

.vision-content {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4rem;
}

.section-subtitle {
  font-size: 1.2rem;
  font-weight: 600;
  color: #666;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 1rem;
}

.section-title {
  font-size: 3rem;
  font-weight: 700;
  color: #e10f28;
  line-height: 1.1;
  margin-bottom: 0.5rem;
}

.drive-by {
  color: #333;
  font-weight: 300;
}

.drive-by-mission {
  color: #333;
}

.vision-mission-grid {
  display: flex;
  flex-direction: column;
  gap: 3rem;
  margin-top: 3rem;
}

.subsection-wrapper {
  display: flex;
  align-items: flex-start;
  gap: 1.5rem;
}

.icon-wrapper {
  width: 60px;
  height: 60px;
  background-color: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.subsection-icon {
  width: 30px;
  height: 30px;
}

.subsection-content {
  flex: 1;
}

.subsection-title {
  font-size: 1.8rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 1rem;
}

.subsection-text {
  font-size: 1.1rem;
  color: #666;
  line-height: 1.7;
  margin: 0;
}

.mission-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.mission-item {
  font-size: 1.1rem;
  color: #666;
  line-height: 1.7;
  margin-bottom: 1rem;
  padding-left: 1.5rem;
  position: relative;
}

.mission-item:before {
  content: '';
  position: absolute;
  left: 0;
  top: 0.7rem;
  width: 8px;
  height: 8px;
  background-color: #e10f28;
  border-radius: 50%;
}

.mission-item:last-child {
  margin-bottom: 0;
}

.vision-image {
  padding: 4rem;
}

.vision-img {
  width: 100%;
  height: 80vh;
  object-fit: cover;
  border-radius: 8px;
}

/* Section 3: Principles */
.principles-section {
  min-height: 80vh;
  display: flex;
  align-items: center;
  background-color: #fff;
  padding: 2rem 0;
}

.principles-content {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4rem;
}

.principles-img {
  width: 100%;
  height: 80vh;
  object-fit: cover;
}

.principles-title {
  font-size: 3rem;
  font-weight: 700;
  color: #e10f28;
  line-height: 1.1;
  margin-bottom: 3rem;
}

.unity {
  color: #333;
  font-weight: 300;
}

.principles-grid {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.principle-item {
  display: flex;
  align-items: flex-start;
  gap: 1.5rem;
}

.principle-icon {
  width: 50px;
  height: 50px;
  flex-shrink: 0;
}

.principle-text h3 {
  font-size: 1.5rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 0.5rem;
}

.principle-text p {
  color: #666;
  line-height: 1.5;
  margin: 0;
}

/* Section 4: Anagrams */
.anagrams-section {
  padding: 5rem 2rem;
  background-color: #f8f9fa;
}

.section-header {
  text-align: center;
  margin-bottom: 3rem;
}

.section-header h2 {
  font-size: 2.5rem;
  font-weight: 700;
  color: #e10f28;
  margin-bottom: 1rem;
}

.section-header p {
  font-size: 1.2rem;
  color: #666;
  max-width: 600px;
  margin: 0 auto;
}

.anagrams-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
  max-width: 1200px;
  margin: 0 auto;
}

.anagram-card {
  background: transparent;
  border-radius: 8px;
  padding: 2rem;
  box-shadow: none;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  border-left: 4px solid #e10f28;
}

.anagram-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 15px rgba(0, 0, 0, 0.15);
}

.anagram-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: #e10f28;
  margin-bottom: 1rem;
}

.anagram-description {
  color: #666;
  line-height: 1.6;
  white-space: pre-line;
  margin: 0;
}

/* Section 5: Structure */
.structure-section {
  padding: 5rem 2rem;
  background-color: #fff;
}

.structure-section .row {
  flex-direction: column;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
}

.structure-content {
  padding: 2rem;
  text-align: center;
}

.structure-content h2 {
  font-size: 2.5rem;
  font-weight: 700;
  color: #e10f28;
  margin-bottom: 1.5rem;
}

.structure-content p {
  font-size: 1.1rem;
  color: #666;
  line-height: 1.7;
  margin-bottom: 2rem;
}

.structure-image {
  padding: 2rem 0;
  width: 100%;
}

.structure-img {
  width: 100%;
  object-fit: contain;
}

/* Section 6: Anggaran Dasar */
.ad-section {
  padding: 5rem 2rem;
  background-color: #f8f9fa;
}

.ad-section .row {
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
}

.ad-image {
  padding: 2rem;
}

.ad-img {
  width: 100%;
  height: auto;
  object-fit: contain;
  transform: scale(0.85);
}

.ad-content {
  padding: 2rem;
}

.ad-content h2 {
  font-size: 2.5rem;
  font-weight: 700;
  color: #e10f28;
  margin-bottom: 1.5rem;
}

.ad-content p {
  font-size: 1.1rem;
  color: #666;
  line-height: 1.7;
  margin-bottom: 2rem;
}

/* Buttons */
.view-structure-btn,
.download-ad-btn {
  background-color: #e10f28 !important;
  border-color: #e10f28 !important;
  color: #fff !important;
  border-radius: 50px !important;
  padding: 0.75rem 2rem !important;
  font-weight: 600 !important;
  font-size: 1rem !important;
  height: auto !important;
}

.view-structure-btn:hover,
.download-ad-btn:hover {
  background-color: #d62828 !important;
  border-color: #d62828 !important;
}

/* Responsive Design */
@media (max-width: 1024px) {
  .anagrams-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .legacy-title,
  .section-title,
  .principles-title {
    font-size: 2.8rem;
  }
}

@media (max-width: 768px) {
  .legacy-section .row,
  .vision-mission-section .row,
  .principles-section .row,
  .structure-section .row,
  .ad-section .row {
    flex-direction: column;
  }

  .col-6 {
    width: 100% !important;
  }

  .hero-image,
  .vision-img,
  .principles-img {
    height: 50vh;
  }

  .legacy-content,
  .vision-content,
  .principles-content {
    padding: 2rem;
  }

  .anagrams-grid {
    grid-template-columns: 1fr;
  }

  .legacy-title,
  .section-title,
  .principles-title {
    font-size: 2.2rem;
  }

  .section-header h2,
  .structure-content h2,
  .ad-content h2 {
    font-size: 2rem;
  }

  .vision-mission-section .row {
    flex-direction: column-reverse;
  }
}

@media (max-width: 480px) {
  .anagrams-section,
  .structure-section,
  .ad-section {
    padding: 3rem 1rem;
  }

  .principle-item {
    flex-direction: column;
    text-align: center;
    gap: 1rem;
  }

  .legacy-title,
  .section-title,
  .principles-title {
    font-size: 1.8rem;
  }

  .legacy-text p,
  .vision-text,
  .mission-item,
  .structure-content p,
  .ad-content p {
    font-size: 1rem;
  }

  .vision-section,
  .mission-section {
    margin-bottom: 2rem;
  }

  .structure-img,
  .ad-img {
    height: 300px;
  }
}
</style>
